import { render, staticRenderFns } from "./ECN2024.vue?vue&type=template&id=5a8b1cb4&scoped=true"
import script from "./ECN2024.vue?vue&type=script&lang=js"
export * from "./ECN2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b1cb4",
  null
  
)

export default component.exports